import { networkService } from "services/networkService";
import {
  METHOD_TERRAFORM_LIST,
  METHOD_TERRAFORM_CREATE,
  METHOD_TERRAFORM_UPDATE,
  METHOD_TERRAFORM_DELETE,
  METHOD_TERRAFORM_DETAIL,

  METHOD_GOLANG_LIST,
  METHOD_GOLANG_CREATE,
  METHOD_GOLANG_UPDATE,
  METHOD_GOLANG_DELETE,
  METHOD_GOLANG_DETAIL,

  METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_LIST,
  METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_CREATE,
  METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_UPDATE,
  METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_DELETE,
  METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_DETAIL,
  
} from "constants/admin/masters/terraform";


class terraformObjectServices {

  //Terraform
  getAllTerraform = (data) => {
    return networkService
      .post(METHOD_TERRAFORM_LIST, data)
      .then((response) => response.data);
  };
  getTerraformDetail = (id) => {
    const updatedMethodName = METHOD_TERRAFORM_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createTerraform = (data) => {
    return networkService
      .post(METHOD_TERRAFORM_CREATE, data)
      .then((response) => response.data);
  };
  updateTerraform = (data, id) => {
    const updatedMethodName = METHOD_TERRAFORM_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteTerraform = (id, is_delete = false) => {
    const updatedMethodName = METHOD_TERRAFORM_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName, { data: { is_delete } })
      .then((response) => response.data);
  };

  //Golang
  getAllGolang = (data) => {
    return networkService
      .post(METHOD_GOLANG_LIST, data)
      .then((response) => response.data);
  };
  getGolangDetail = (id) => {
    const updatedMethodName = METHOD_GOLANG_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createGolang = (data) => {
    return networkService
      .post(METHOD_GOLANG_CREATE, data)
      .then((response) => response.data);
  };
  updateGolang = (data, id) => {
    const updatedMethodName = METHOD_GOLANG_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteGolang = (id, is_delete = false) => {
    const updatedMethodName = METHOD_GOLANG_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName, { data: { is_delete } })
      .then((response) => response.data);
  };

  //VSP One Block Terraform Provider
  getAllVSPOneBlockTerraformProvider = (data) => {
    return networkService
      .post(METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_LIST, data)
      .then((response) => response.data);
  };
  getVSPOneBlockTerraformProviderDetail = (id) => {
    const updatedMethodName = METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createVSPOneBlockTerraformProvider = (data) => {
    return networkService
      .post(METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_CREATE, data)
      .then((response) => response.data);
  };
  updateVSPOneBlockTerraformProvider = (data, id) => {
    const updatedMethodName = METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteVSPOneBlockTerraformProvider = (id, is_delete = false) => {
    const updatedMethodName = METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName, { data: { is_delete } })
      .then((response) => response.data);
  };

}
export default terraformObjectServices;